import React, { useState, useRef, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import faq from '../images/frequently-asked-questions-solution-concept.webp';
import { FaAngleUp, FaAngleDown } from "react-icons/fa";

const ServiceFaqSection = ({
  faqData,
  intro = 'Quick answers about our services.',
  image = faq,
  imageAlt = '',
  title = 'Frequently Asked Questions',
  imageStyle = {},
  enableScrollableContainer = false,
  maxScrollHeight = '520px',
}) => {
  const [openIndex, setOpenIndex] = useState(null);
  const scrollRef = useRef(null);
  const [hasScroll, setHasScroll] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const checkScrollState = () => {
    if (scrollRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
      const canScroll = scrollHeight > clientHeight + 5;
      setHasScroll(canScroll);

      // Detect bottom position with 15px tolerance
      const atBottom = scrollTop + clientHeight >= scrollHeight - 15;
      setIsAtBottom(atBottom);
    }
  };

  useEffect(() => {
    if (enableScrollableContainer) {
      const timer = setTimeout(() => {
        checkScrollState();
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [openIndex, enableScrollableContainer]);

  const handleScroll = () => {
    if (enableScrollableContainer) {
      checkScrollState();
    }
  };

  const handleIndicatorClick = () => {
    if (scrollRef.current) {
      if (isAtBottom) {
        scrollRef.current.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        scrollRef.current.scrollBy({ top: 260, behavior: 'smooth' });
      }
    }
  };

  return (
    <div className="faqContainer">
      <Container>
        <Row className="align-items-center">
          <Col lg="8" md="6" sm="12" className="accordion_left">
            <div className="hospitality_faq">
              <div className="hospitality_faq_header">
                <h1>{title}</h1>
                <p className="faq_intro">{intro}</p>
              </div>

              <div className="faq_scroll_wrapper">
                <div
                  ref={scrollRef}
                  onScroll={handleScroll}
                  className={`accordion hospitality_faq_body ${
                    enableScrollableContainer ? 'faq_scrollable_container' : ''
                  }`}
                  style={
                    enableScrollableContainer
                      ? {
                          maxHeight: maxScrollHeight,
                          overflowY: 'auto',
                          scrollbarWidth: 'none',
                          msOverflowStyle: 'none',
                        }
                      : {}
                  }
                >
                  {faqData.map((item, index) => (
                    <div
                      key={index}
                      className={`accordion-item ${
                        openIndex === index ? 'is-open' : ''
                      }`}
                    >
                      <div
                        className="accordion-question"
                        onClick={() => toggleAccordion(index)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            toggleAccordion(index);
                          }
                        }}
                      >
                        <h2>{item.question}</h2>
                        {openIndex === index ? <FaAngleUp /> : <FaAngleDown />}
                      </div>
                      {openIndex === index && (
                        <div className="accordion-answer">{item.answer}</div>
                      )}
                    </div>
                  ))}
                </div>

                {enableScrollableContainer && hasScroll && (
                  <>
                    {!isAtBottom && <div className="faq_bottom_fade_cue" />}
                    <button
                      type="button"
                      className="faq_scroll_indicator_btn"
                      onClick={handleIndicatorClick}
                      title={isAtBottom ? 'Scroll to top' : 'Scroll down for more FAQs'}
                    >
                      {isAtBottom ? <FaAngleUp /> : <FaAngleDown />}
                    </button>
                  </>
                )}
              </div>
            </div>
          </Col>
          <Col lg="4" md="6" sm="12" className="accordion_right d-flex align-items-center justify-content-center">
            <div className="faq_Image w-100 text-center">
              <img
                src={image}
                className="img-fluid"
                alt={imageAlt}
                style={{ borderRadius: '20px', ...imageStyle }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ServiceFaqSection;
